import { LocalizedStringsMethods } from 'react-localization';
import LocalizedStrings  from 'react-localization';

interface IAddEditProfileStrings extends LocalizedStringsMethods {
    lsFirstNamePlaceHolderTxt: string;
    lsMiddletNamePlaceHolderTxt: string;
    lsLastNamePlaceHolderTxt: string;
    lsAddProfileTxt: string;
    lsEditProfileTxt: string;
    lsHomeTxt: string;
    lsAddTxt: string;
    lsEditTxt: string;
    lsSaveTxt: string;
    lsFirstName: string;    
    lsMiddleName: string;
    lsLastName: string;    
    lsSelectGenderTxt: string;
    lsMaleTxt: string;
    lsFemaleTxt: string;
    lsOtherTxt: string;
    lsUnspecifiedTxt: string;
    lsSelectLevelTxt: string;
    lsCancelTxt: string;
    lsAddProfileSuccessTxt: string;
    lsAddProfileFailedTxt: string;
    lsUpdateProfileSuccessTxt: string;
    lsOrgTxt: string;
    lsLevelTxt: string;
    lsProfilesTxt: string;
    lsIDTxt: string;
    lsSportTxt: string;
    lsBDayTxt: string;
    lsGenderTxt: string;
    lsBaselineTxt: string;
    lsTotalTestTxt: string;
    lsContactInfoTxt: string;
    lsEmailTxt: string;
    lsPhoneTxt: string;
    lsNotifyEmailTxt: string;
    lsNotifyPhonesTxt: string;
    lsTestHistoryTxt: string;
    lsShareTextTxt: string;
    lsPrintTxt: string;
    lsDownloadTxt: string;
    lsExportTxt: string;
    lsOkTxt: string;
    lsTestExportSuccessTxt: string;
    lsTestSharedSuccessTxt: string;
    lsTestShareFailTxt: string;    
}

let strings: IAddEditProfileStrings;
export default strings = new LocalizedStrings({
    en: {
        lsFirstNamePlaceHolderTxt: 'e.g. Johnny',
        lsMiddletNamePlaceHolderTxt: 'e.g. Jack',
        lsLastNamePlaceHolderTxt: 'e.g Thomas',
        lsAddProfileTxt: 'Add Profile',
        lsEditProfileTxt: 'Edit Profile',
        lsHomeTxt: 'Home',
        lsAddTxt: 'Add',
        lsEditTxt: 'Edit',
        lsSaveTxt: 'Save',
        lsFirstName: 'First Name',  
        lsMiddleName: 'Middle Name',
        lsLastName: 'Last Name',
        lsBDayTxt: 'Birthdate',
        lsSelectGenderTxt: 'Select Gender',
        lsMaleTxt: 'Male',
        lsFemaleTxt: 'Female',
        lsOtherTxt: 'Other',
        lsUnspecifiedTxt: 'Unspecified',
        lsSelectLevelTxt: 'Select Level',
        lsCancelTxt: 'Cancel',
        lsAddProfileSuccessTxt: 'Profile added successfully!',
        lsAddProfileFailedTxt: 'Failed to add profile',
        lsUpdateProfileSuccessTxt: 'Profile updated successfully!',
        lsOrgTxt: 'Organization',
        lsLevelTxt: 'Level',
        lsProfilesTxt: 'Profile',        
        lsIDTxt: 'Id',
        lsSportTxt: 'Sport',        
        lsGenderTxt: 'Gender',
        lsBaselineTxt: 'Baseline',
        lsTotalTestTxt: 'Total Tests',
        lsContactInfoTxt: 'Contact & Notify Info',
        lsEmailTxt: 'Email',
        lsPhoneTxt: 'Phone',
        lsNotifyEmailTxt: 'Notify Email(s)',
        lsNotifyPhonesTxt: 'Notify Phone(s)',
        lsTestHistoryTxt: 'Test History',
        lsShareTextTxt: 'Share Test',
        lsPrintTxt : 'Print',
        lsDownloadTxt: 'Download',
        lsExportTxt: 'Export Profile List',
        lsOkTxt: 'Ok',
        lsTestExportSuccessTxt: 'Tests exported successfully!',        
        lsTestSharedSuccessTxt: 'Tests shared successfully!',
        lsTestShareFailTxt: 'Tests could not be shared.Please try again!'

    },
    es: {
        lsFirstNamePlaceHolderTxt: 'p.ej. Johnny',
        lsMiddletNamePlaceHolderTxt: 'p.ej. Johnny',
        lsLastNamePlaceHolderTxt: 'p.ej. Johnny',
        lsAddProfileTxt: 'Añadir perfil',
        lsEditProfileTxt: 'Editar perfil',
        lsHomeTxt: 'Casa',
        lsAddTxt: 'Añadir',
        lsEditTxt: 'Editar',
        lsSaveTxt: 'Salvar',
        lsFirstName: 'Nombre de pila',  
        lsMiddleName: 'Segundo nombre',
        lsLastName: 'Apellido',
        lsBDayTxt: 'Fecha de nacimiento',
        lsSelectGenderTxt: 'Seleccione género',
        lsMaleTxt: 'Masculino',
        lsFemaleTxt: 'Hembra',
        lsOtherTxt: 'Otro',
        lsUnspecifiedTxt: 'Sin especificar',
        lsSelectLevelTxt: 'Selecciona el nivel',
        lsCancelTxt: 'Cancelar',
        lsAddProfileSuccessTxt: 'Perfil agregado con éxito!',
        lsAddProfileFailedTxt: 'Failed to add profile',
        lsUpdateProfileSuccessTxt: '¡Perfil actualizado con éxito!',
        lsOrgTxt: 'Organización',
        lsLevelTxt: 'Nivel',
        lsProfilesTxt: 'Profile',        
        lsIDTxt: 'Carné de identidad',
        lsSportTxt: 'Deportes',        
        lsGenderTxt: 'Género',
        lsBaselineTxt: 'Base',
        lsTotalTestTxt: 'Pruebas totales',
        lsContactInfoTxt: 'Contacto y notificación de información',
        lsEmailTxt: 'Email',
        lsPhoneTxt: 'Teléfono',
        lsNotifyEmailTxt: 'Notificar correo electrónico (s)',
        lsNotifyPhonesTxt: 'Notificar teléfono (s)',
        lsTestHistoryTxt: 'Historial de prueba',
        lsShareTextTxt: 'Compartir prueba',
        lsPrintTxt : 'Impresión',
        lsDownloadTxt: 'Descargar',
        lsExportTxt: 'Exportar lista de perfiles',
        lsOkTxt: 'De acuerdo',
        lsTestExportSuccessTxt: 'Pruebas exportadas con éxito',        
        lsTestSharedSuccessTxt: '¡Pruebas compartidas exitosamente!',
        lsTestShareFailTxt: 'Las pruebas no se pudieron compartir. ¡Inténtalo de nuevo!'
     }
});


// WEBPACK FOOTER //
// ./src/eyeguide-localization/profile/strings.profile.addedit.tsx